(() => {
  const MAX_COUNTRY_COLLAPSED = 9999; // no collapse for now

  // Check with Shinji-san about these settings if needed or delete it
  // const LOW_STOCK_THRESHOLD = 5;
  const TREAT_CONTINUE_ZERO_AS_SOLD_OUT = false; // if true, qty=0 disables card even if oversell allowed

  // ---------- State ----------
  const state = {
    category: "domestic",
    days: "365",
    region: null, // 'asia' | 'eu' | 'na' | 'sa' | 'af' | 'oc' | null
    country: null, // e.g., 'korea', 'japan', etc.
    countryExpanded: false,
  };

  const REGION_LABELS = {
    global: "世界周遊",
    asia: "アジア",
    eu: "ヨーロッパ",
    na: "北米",
    sa: "南米",
    af: "アフリカ",
    oc: "オセアニア",
  };
  const REGION_ORDER = ["global", "asia", "eu", "na", "sa", "af", "oc"];

  // ---------- DOM refs ----------
  const $categoryTabs = () => document.getElementById("categoryTabs");
  const $regionTabs = () => document.getElementById("regionTabs");
  const $dayTabs = () => document.getElementById("dayTabs");
  const $plans = () => document.getElementById("plansContainer");

  // Check with Shinji-san about these settings if needed or delete it
  function isTracked(plan) {
    // 'shopify' when tracked; null/empty means not tracked
    return Boolean(plan?.inventory_management);
  }

  function isSoldOut(plan) {
    const q = Number(plan?.inventory_qty);

    // If store policy allows oversell, decide based on our flag
    if (plan?.inventory_policy === "continue") {
      if (TREAT_CONTINUE_ZERO_AS_SOLD_OUT && Number.isFinite(q) && q <= 0) {
        return true; // disable card when qty=0 even if oversell allowed
      }
      return false; // otherwise allow purchasing 
    }

    // Normal deny policy
    if (plan?.available === false) return true;
    if (!isTracked(plan)) return false;
    return Number.isFinite(q) && q <= 0;
  }

  // Optional: show a badge when you allow backorders (continue policy) but qty is 0
  // function backorderLabel(plan) {
  //   const q = Number(plan?.inventory_qty);
  //   if (plan?.inventory_policy === "continue" && Number.isFinite(q) && q <= 0) {
  //     return "在庫0（注文可）";
  //   }
  //   return "";
  // }

  // Optional: show a badge when stock is low
  // function lowStockLabel(plan) {
  //   if (!isTracked(plan)) return "";
  //   const q = Number(plan?.inventory_qty);
  //   return Number.isFinite(q) && q > 0 && q <= LOW_STOCK_THRESHOLD
  //     ? `残り${q}点`
  //     : "";
  // }

  // ---------- Data ----------
  function getPlanData() {
    const el = document.getElementById("planData");
    if (!el) return { domestic: { 365: [], 30: [] }, global: {} };
    try {
      return JSON.parse(el.textContent || "{}");
    } catch (e) {
      console.error("[okawari] planData JSON parse error:", e, el.textContent);
      return { domestic: { 365: [], 30: [] }, global: {} };
    }
  }

  const PLAN_DATA = getPlanData();
  // Ensure global overview list exists; synthesize if absent
  try {
    if (
      !Array.isArray(PLAN_DATA.global?.["30"]) ||
      PLAN_DATA.global["30"].length === 0
    ) {
      PLAN_DATA.global = PLAN_DATA.global || {};
      PLAN_DATA.global["30"] = getGlobalOverview30();
    }
  } catch {}

  // ---------- Init ----------
  document.addEventListener("DOMContentLoaded", () => {
    bindCategoryTabs();
    renderUI(); // renders regions, days, and plans
  });

  // ---------- UI renderers ----------
  function renderUI() {
    renderRegionTabs();
    renderCountryTabs();
    renderDayTabs();
    renderPlans();
  }

  function bindCategoryTabs() {
    const ct = $categoryTabs();
    if (!ct) return;

    ct.querySelectorAll("button").forEach((btn) => {
      btn.addEventListener("click", () => {
        ct.querySelectorAll("button").forEach((b) =>
          b.classList.remove("active")
        );
        btn.classList.add("active");

        const nextCategory =
          btn.dataset.category === "global" ? "global" : "domestic";
        if (nextCategory === "domestic") {
          state.category = "domestic";
          state.days = "365"; // default
          state.region = null;
        } else {
          state.category = "global";
          state.days = "30"; // default
          state.region = null;
        }
        renderUI();
      });
    });
  }

  function renderCountryTabs() {
    const container = document.getElementById("countryTabs");
    if (!container) return;
    container.innerHTML = "";

    if (
      state.category !== "global" ||
      !state.region ||
      state.region === "global"
    ) {
      container.style.display = "none";
      return;
    }
    container.style.display = "";

    const regionBucket = PLAN_DATA.global?.[state.region];
    if (!regionBucket) {
      container.appendChild(emptyState());
      return;
    }

    const allCountries = Object.keys(regionBucket); // ["korea","japan",...]
    if (allCountries.length === 0) {
      container.appendChild(emptyState());
      return;
    }

    // pick a default if none selected
    if (!state.country || !regionBucket[state.country]) {
      state.country = allCountries[0];
    }

    // collapsed list: first N + ensure selected is visible
    let visibleCountries;
    if (state.countryExpanded || allCountries.length <= MAX_COUNTRY_COLLAPSED) {
      visibleCountries = allCountries;
    } else {
      visibleCountries = allCountries.slice(0, MAX_COUNTRY_COLLAPSED);
      if (!visibleCountries.includes(state.country)) {
        visibleCountries = [...visibleCountries, state.country];
      }
    }

    visibleCountries.forEach((ck) => {
      const btn = document.createElement("button");
      btn.textContent = prettifyCountryKey(ck); // label function below
      if (ck === state.country) btn.classList.add("active");
      btn.addEventListener("click", () => {
        state.country = ck;
        // choose a sensible default day if missing
        const days = Object.keys(regionBucket[ck] || {}); // e.g. ["30","7"]
        state.days = days.includes("30") ? "30" : days[0] || "30"; // ← prefer 30
        // refresh
        renderCountryTabs();
        renderDayTabs();
        renderPlans();
      });
      container.appendChild(btn);
    });

    // render the "… / show all / collapse" toggle if needed
    if (allCountries.length > MAX_COUNTRY_COLLAPSED) {
      const more = document.createElement("button");
      more.className = "more-btn";
      more.textContent = state.countryExpanded ? "閉じる" : "…";
      more.setAttribute("aria-expanded", String(state.countryExpanded));
      more.addEventListener("click", () => {
        state.countryExpanded = !state.countryExpanded;
        renderCountryTabs(); // re-render just the chips
      });
      container.appendChild(more);
    }
  }

  const COUNTRY_LABELS = {
    // Asia
    tr: "トルコ", //Turkey
    cambodia: "カンボジア", //Cambodia
    china: "中国", //China
    india: "インド", //India
    indonesia: "インドネシア", //Indonesia
    malaysia: "マレーシア", //Malaysia
    philippines: "フィリピン", //Philippines
    singapore: "シンガポール", //Singapore
    "south-korea": "韓国", //South Korea
    taiwan: "台湾", //Taiwan
    thailand: "タイ", //Thailand
    vietnam: "ベトナム", //Vietnam,
    // Europe
    cz: "チェコ共和国", //Czech Republic
    pl: "ポーランド", //Poland
    hu: "ハンガリー", //Hungary
    hr: "クロアチア", //Croatia
    gr: "ギリシャ", //Greece
    dk: "デンマーク", //Denmark
    ch: "スイス", //Switzerland
    pt: "ポルトガル", //Portugal
    it: "イタリア", //Italy
    es: "スペイン", //Spain
    fr: "フランス", //France
    de: "ドイツ", //Germany
    nl: "オランダ", //Netherlands
    be: "ベルギー", //Belgium
    gb: "イギリス", //Great Britain
    at: "オーストリア", //Austria
    ru: "ロシア", //Russia
    // North America
    spn: "サイパン", //Saipan
    hawaiiokawari: "ハワイ", //Hawaii
    americaokawari: "アメリカ", //USA
    ca: "カナダ", //Canada
    guam: "グアム", //Guam
    // South America
    uy: "ウルグアイ", //Uruguay
    cl: "チリ", //Chile
    ar: "アルゼンチン", //Argentina
    br: "ブラジル", //Brazil
    co: "コロンビア", //Colombia
    mx: "メキシコ", //Mexico
    // Africa
    za: "南アフリカ", //South Africa
    ke: "ケニア", //Kenya
    ma: "モロッコ", //Morocco
    ng: "ナイジェリア", //Nigeria
    egypt: "エジプト", //Egypt
    gh: "ガーナ", //Ghana
    // Oceania
    nz: "ニュージーランド", //New Zealand
    au: "オーストラリア", //Australia
    spn: "サイパン", //Saipan
    hawaiiokawari: "ハワイ", //Hawaii
  };

  // very simple labelizer; customize or map to JP names later
  function prettifyCountryKey(key) {
    return (
      COUNTRY_LABELS[key] ||
      key.replace(/-/g, " ").replace(/\b\w/g, (m) => m.toUpperCase())
    );
  }

  function renderRegionTabs() {
    const container = $regionTabs();
    if (!container) return;
    container.innerHTML = "";

    if (state.category !== "global") {
      container.style.display = "none";
      return;
    }
    container.style.display = "";

    // Build the 7 region buttons
    REGION_ORDER.forEach((key) => {
      const btn = document.createElement("button");
      btn.textContent = REGION_LABELS[key];
      btn.dataset.region = key;
      btn.className = "region-btn";

      // Active state: if a concrete region is selected OR
      // treat '世界周遊' as active when region is null (overview mode)
      const isActive =
        (state.region && state.region === key) ||
        (!state.region && key === "global");
      if (isActive) btn.classList.add("active");
      btn.setAttribute("aria-pressed", String(isActive));

      btn.addEventListener("click", () => {
        if (key === "global") {
          // Clicking 世界周遊 returns to OVERVIEW
          state.region = null; // IMPORTANT: null means overview
          state.country = null;
          state.days = "30";
          state.countryExpanded = false;
        } else {
          // Concrete region
          state.region = key;
          state.country = null; // reset country when changing region
          state.days = "30";
          state.countryExpanded = false;
        }

        // Toggle active classes
        [...container.querySelectorAll("button")].forEach((b) => {
          b.classList.remove("active");
          b.setAttribute("aria-pressed", "false");
        });
        btn.classList.add("active");
        btn.setAttribute("aria-pressed", "true");

        renderCountryTabs();
        renderDayTabs();
        renderPlans();
      });

      container.appendChild(btn);
    });
  }

  function renderDayTabs() {
    const container = $dayTabs();
    if (!container) return;
    container.innerHTML = "";

    if (state.category === "domestic") {
      const d365 = makeButton("365日", state.days === "365", () => {
        state.days = "365";
        setActive(container, d365);
        renderPlans();
      });
      const d30 = makeButton("30日", state.days === "30", () => {
        state.days = "30";
        setActive(container, d30);
        renderPlans();
      });
      container.style.display = "";
      container.appendChild(d365);
      container.appendChild(d30);
      return;
    }

    // --- GLOBAL ---
    // Overview (世界周遊) → no day controls
    if (!state.region || state.region === "global") {
      container.style.display = "none";
      return;
    }

    // Region chosen but no country yet → no day controls
    if (!state.country) {
      container.style.display = "none";
      return;
    }

    const bucket = PLAN_DATA.global?.[state.region]?.[state.country] || {};
    // Prefer deterministic order: 30 then 7 if they exist
    const days = ["30", "7"].filter((d) => bucket[d]?.length);

    if (days.length === 0) {
      container.style.display = "none";
      return;
    }

    // Make sure container is visible now
    container.style.display = "";

    // Pick a default if current selection isn't available
    if (!days.includes(state.days)) {
      state.days = days[0];
    }

    days.forEach((d) => {
      const label = `${d}日`;
      const btn = makeButton(label, state.days === d, () => {
        state.days = d;
        setActive(container, btn);
        renderPlans();
      });
      container.appendChild(btn);
    });
  }

  function renderPlans() {
    const container = $plans();
    if (!container) return;
    container.innerHTML = "";

    let plans = getCurrentPlans() || [];

    // sort by capacity (asc). tie-breakers: price, then title.
    plans = [...plans].sort((a, b) => {
      const ac = Number(a.capacity_gb);
      const bc = Number(b.capacity_gb);
      if (!Number.isNaN(ac) && !Number.isNaN(bc) && ac !== bc) return ac - bc;

      const ap = Number(a.price);
      const bp = Number(b.price);
      if (!Number.isNaN(ap) && !Number.isNaN(bp) && ap !== bp) return ap - bp;

      return String(a.title || "").localeCompare(String(b.title || ""));
    });

    if (plans.length === 0) {
      container.appendChild(emptyState());
      return;
    }

    plans.forEach((plan) => container.appendChild(makePlanCard(plan)));
  }

  function getGlobalOverview30() {
    // Prefer server-provided overview if present
    const server = PLAN_DATA.global?.["30"];
    if (Array.isArray(server) && server.length) return server;

    // Fallback: synthesize one 30-day example per region from countries
    const regions = ["asia", "eu", "na", "sa", "af", "oc"]; // match REGION_ORDER (minus "global")
    const out = [];
    regions.forEach((region) => {
      const bucket = PLAN_DATA.global?.[region];
      if (!bucket) return;
      const countries = Object.keys(bucket);
      for (const ck of countries) {
        const list30 = bucket[ck]?.["30"];
        if (Array.isArray(list30) && list30.length) {
          const plan = { ...list30[0], region, country: ck };
          out.push(plan);
          break; // only one representative per region
        }
      }
    });
    return out;
  }

  function getCurrentPlans() {
    if (state.category === "domestic") {
      return PLAN_DATA.domestic?.[state.days] || [];
    }
    // GLOBAL
    if (!state.region || state.region === "global") {
      // overview list (30日 cards per region) — keep using global["30"] if you output it
      return PLAN_DATA.global?.["30"] || [];
    }

    if (!state.country) {

      return [];
    }

    const bucket = PLAN_DATA.global?.[state.region]?.[state.country] || {};
    return bucket[state.days] || [];
  }

  // ---------- Components ----------
  function makeButton(label, active, onClick, disabled = false) {
    const btn = document.createElement("button");
    btn.textContent = label;
    if (active) btn.classList.add("active");
    if (disabled) {
      btn.disabled = true; // native disable
      btn.classList.add("is-disabled"); // for styling
      btn.setAttribute("aria-disabled", "true");
    }
    btn.addEventListener("click", (e) => {
      if (btn.disabled) {
        e.preventDefault();
        e.stopPropagation();
        return; // do nothing if disabled
      }
      onClick?.(e);
    });
    return btn;
  }

  function setActive(container, activeBtn) {
    container
      .querySelectorAll("button")
      .forEach((b) => b.classList.remove("active"));
    if (activeBtn) activeBtn.classList.add("active");
  }

  function emptyState() {
    const p = document.createElement("p");
    p.className = "okawari-empty";
    p.textContent = "プランが見つかりません。";
    return p;
  }

  function makePlanCard(plan) {
    // Check with Shinji-san about these settings if needed or delete it
    const soldOut = isSoldOut(plan);
    // const lowNote = lowStockLabel(plan);
    // const backNote = backorderLabel(plan);

    // Expected plan: { id, title, money, price, image }
    const a = document.createElement("a");
    a.href = "#";
    a.className = "plan-card";
    a.dataset.variantId = String(plan.id);
    a.setAttribute("role", "button");
    a.setAttribute("aria-label", (plan.title || "プラン") + " をカートに追加");

    // image (optional)
    if (plan.image) {
      const img = document.createElement("img");
      img.src = plan.image;
      img.alt = plan.title || "";
      img.width = 300;
      img.height = 300;
      img.loading = "lazy";
      img.decoding = "async";
      img.className = "plan-100";
      a.appendChild(img);
    }

    // Check with Shinji-san about these settings if needed or delete it
    const LABELS = {
      soldOut: "売り切れ", //Sold Out
      lowStock: (q) => `残り${q}点`, // e.g. "Only 3 left"
      backorder: "在庫0（注文可）", // or "Preorder available"
    };

    // BADGE
    if (soldOut) {
      const badge = document.createElement("div");
      badge.className = "plan-badge pill sold-out";
      badge.textContent = LABELS.soldOut;
      a.appendChild(badge);
      a.classList.add("is-sold-out");
      a.setAttribute("aria-disabled", "true");
      a.tabIndex = -1;
    }
    // } else if (lowNote) {
    //   const badge = document.createElement("div");
    //   badge.className = "plan-badge low-stock";
    //   badge.textContent = LABELS.lowStock(Number(plan.inventory_qty));
    //   a.appendChild(badge);
    // } else if (backNote) {
    //   const badge = document.createElement("div");
    //   badge.className = "plan-badge low-stock";
    //   badge.textContent = LABELS.backorder;
    //   a.appendChild(badge);
    // }

    // title
    const title = document.createElement("div");
    title.className = "plan-card-title";
    title.textContent = plan.title || "";
    a.appendChild(title);

    // price
    const price = document.createElement("div");
    price.className = "plan-card-price";
    price.textContent =
      typeof plan.money === "string" && plan.money.length
        ? plan.money
        : formatMoney(plan.price);
    a.appendChild(price);

    // location label
    const loc = document.createElement("div");
    loc.className = "plan-card-location";
    loc.dataset.dynamicLocation = "";
    loc.textContent = makeLocationLabel(plan);
    a.appendChild(loc);

    // click → add to cart (with double-click guard)
    a.addEventListener("click", (e) => {
      e.preventDefault();

      // Check with Shinji-san about these settings if needed or delete it
      if (soldOut || a.dataset.available === "0") {
        showToast("在庫がありません。");
        return;
      }

      if (a.dataset.loading === "1") return; // guard
      a.dataset.loading = "1";
      a.classList.add("is-loading");
      a.setAttribute("aria-busy", "true");

      addToCart(a)
        .catch(() => {
          // optional UX: already handled in addToCart
        })
        .finally(() => {
          a.dataset.loading = "0";
          a.classList.remove("is-loading");
          a.removeAttribute("aria-busy");
        });
    });

    return a;
  }

  function makeLocationLabel(plan) {
    if (state.category === "domestic") {
      // 国内プランには容量も付けたい場合
      return `国内 ${state.days}日 ${plan.capacity_gb || ""}GB`;
    }

    const regionKey = state.region || plan?.region || "global";
    const regionName = REGION_LABELS[regionKey] || "世界周遊";
    const countryName = state.country ? prettifyCountryKey(state.country) : "";

    // add GB before region/day
    const gbLabel = plan.capacity_gb ? `${plan.capacity_gb}GB ` : "";

    return `${countryName ? countryName + " " : ""}${regionName} ${state.days}日 ${gbLabel}`;
  }

  // ---------- Money util ----------
  function formatMoney(priceCents) {
    // Fallback if money string not provided by Liquid JSON
    if (typeof priceCents !== "number") return "";
    // JPY, no decimals
    try {
      return new Intl.NumberFormat("ja-JP", {
        style: "currency",
        currency: "JPY",
        maximumFractionDigits: 0,
      }).format(priceCents / 100);
    } catch {
      return `¥${Math.round(priceCents / 100).toLocaleString("ja-JP")}`;
    }
  }

  // ---------- Drawer API ----------
  window.openOkawariDrawer = function (label, serial) {
    try {
      sessionStorage.setItem("selectedSerial", serial || "");
    } catch {}
    const drawer = document.getElementById("okawariDrawer");
    if (drawer) {
      drawer.classList.add("show");
      document.body.style.overflow = "hidden";
    }
  };

  window.closeOkawariDrawer = function () {
    const drawer = document.getElementById("okawariDrawer");
    if (drawer) {
      drawer.classList.remove("show");
    }
    document.body.style.overflow = "";
  };

  // ---------- Cart + toast (preserved from your file) ----------
  function animateCartIcon() {
    const cartIcon = document.querySelector("#cart-icon-bubble");
    if (!cartIcon) return;
    cartIcon.classList.add("bump");
    setTimeout(() => cartIcon.classList.remove("bump"), 300);
  }

  function addToCart(el) {
    const variantId = el?.dataset?.variantId;
    if (!variantId) {
      console.error("[okawari] Missing variantId on element");
      showToast("追加に失敗しました。もう一度お試しください。");
      return Promise.reject(new Error("Missing variantId"));
    }

    let serial = null;
    try {
      serial = sessionStorage.getItem("selectedSerial") || null;
    } catch {
      serial = null;
    }

    // T9 devices can only purchase Japan plans.
    // T9が購入できる日本プランvariantId一覧
    const japanPlanVariantIds = [
      '41040512385112', '40729000247384', '40729000214616',
      '40729000181848', '40729000149080', '42249364668504',
      '41040511598680', '40729013059672', '40729013026904',
      '40729012994136', '40729012961368'
    ];
    // serialが存在し、T9端末(=29で始まる)かつ日本プラン以外を選択した場合
    if (serial && serial.startsWith("29") && !japanPlanVariantIds.includes(variantId)) {
      showToast("端末：T9では海外プランは購入できません。");
      throw new Error("Overseas plan purchase not allowed for T9");
    }

    return fetch("/cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        id: variantId,
        quantity: 1,
        properties: { SN: serial || "-" },
      }),
    })
      .then(async (res) => {
        // Shopify returns 200/OK with JSON or 4xx with JSON error
        const data = await res.json().catch(() => ({}));
        if (!res.ok) {
          const msg =
            (data && (data.description || data.message)) ||
            "追加に失敗しました。もう一度お試しください。";
          throw new Error(msg);
        }
        return data;
      })
      .then(() => {
        // Theme pub/sub guard
        if (
          typeof publish === "function" &&
          typeof PUB_SUB_EVENTS !== "undefined"
        ) {
          publish(PUB_SUB_EVENTS.cartUpdate, {
            source: "external-okawari",
            variantId,
          });
        }
        animateCartIcon?.();
        refreshCartIcon?.();
        showToast("🛒 プランをカートに追加しました！");
        setTimeout(() => {
          window.location.href = "/cart";
        }, 800);
      })
      .catch((err) => {
        console.error("Add to cart failed:", err);
        showToast(
          typeof err?.message === "string" && err.message
            ? `追加に失敗しました：${err.message}`
            : "追加に失敗しました。もう一度お試しください。"
        );
        throw err; // keep promise rejected for upstream handlers
      });
  }

  function refreshCartIcon() {
    fetch("/?section_id=header")
      .then((res) => res.text())
      .then((html) => {
        const doc = new DOMParser().parseFromString(html, "text/html");
        const newIcon = doc.querySelector("#cart-icon-bubble");
        const oldIcon = document.querySelector("#cart-icon-bubble");
        if (newIcon && oldIcon) {
          oldIcon.replaceWith(newIcon);
          updateCartBadgeCount();
        }
      })
      .catch(() => {});
  }

  function updateCartBadgeCount() {
    fetch("/cart.js")
      .then((res) => res.json())
      .then((cart) => {
        const badge = document.querySelector(
          "#cart-icon-bubble .cart-count-bubble span"
        );
        if (badge && badge.parentElement) {
          badge.textContent = cart.item_count;
          badge.parentElement.style.display =
            cart.item_count > 0 ? "block" : "none";
        }
      })
      .catch(() => {});
  }

  function showToast(message = "商品をカートに追加しました！") {
    const toast = document.getElementById("toast");
    const toastMsg = document.getElementById("toast-message");
    if (!toast || !toastMsg) return;
    toastMsg.textContent = message;
    toast.classList.add("show");
    setTimeout(() => toast.classList.remove("show"), 2500);
  }
})();
